import { BasilDocumentOutline, Contact, Email, JobPerson, MingcuteBuilding5Line, Person, Product, Status, UilUser } from "../../assets/icon/iconify";

interface Props {
    type: number;
    proposalPreparedBy?: string;
}

export const GetIcon = ({ type, proposalPreparedBy }: Props) => {
    switch (type) {
        case 1:
            return <UilUser width={17} height={17} />;
        case 2:
            return <Contact color='#186cb2' size={18} />;
        case 3:
            return <Email color='#186cb2' size={18} />;
        case 4:
            return <JobPerson color='#186cb2' size={18} />;
        case 5:
            return <BasilDocumentOutline width={18} height={18} />;
        case 6: 
            return <Product color='#186cb2' size={18} />;
        case 7: 
            return <MingcuteBuilding5Line width={18} height={18} />;
        case 8: 
            // return <p className='text-[#186cb2] text-[11px] px-[5px]'>{proposalPreparedBy?.[0]}</p>;
            return <UilUser width={17} height={17} />;
        case 9:
            return <Status size={18}/>
        default:
            return <Person color="#186cb2" size={18} />;
    }
}